<template>
    <div>
    <div class="c"></div>
    <div id="bd">
        <div id="ban-in" class="bannerImg">
            <div class="ban-bg"></div>
        </div>
        
        <div class="wp dxal">
            <div class="tit-i">
                <h3>典型案例</h3>
                <h5><span>CLASSIC</span> CASE</h5>
            </div>
            <!-- <div class="contact-l ">
               <div class="al-title">盘锦市住房公积金管理中心</div>
               <p>盘锦市住房公积金管理中心现已开通用公积金按月还贷业务，请本人携带身份证到原贷款办事处签署协议。如用夫妻双方公积金还贷须双方同时到场。</p>
               <p>盘锦市住房公积金管理中心现已开通用公积金按月还贷业务，请本人携带身份证到原贷款办事处签署协议。如用夫妻双方公积金还贷须双方同时到场。</p>
            </div> -->
            <!-- <div class="contact-r "> -->
               <!-- <video src="../assets/video.mp4" width="100%" controls></video> -->
               <!-- <video src="../assets/xz.mp4" width="100%" controls></video> -->
                <div id="banner">
                    <!-- <div class="banner-bg"></div> -->
                    <div class="flexslider">
                        <ul class="slides">
                            <li class="s1"> 
                                <video src="../assets/xz.mp4" width="100%" controls></video>
                                <!-- <img src="../assets/Images/indexbanner.jpg" alt="某某网站建设，北京网站建设"> -->
                                <div class="video-title">
                                    <div>盘锦新闻</div>
                                </div>
                            </li>
                            <!-- <li class="s2"> 
                                 <video src="../assets/xz.mp4" width="100%" controls></video>
                                 <div class="video-title">
                                    <div>不只是建站，更提供有价值的思路和整体服务</div>
                                </div>
                            </li>
                            <li class="s3"> 
                                 <video src="../assets/xz.mp4" width="100%" controls></video>
                                 <div class="video-title">
                                    <div>不只是建站，更提供有价值的思路和整体服务</div>
                                </div>
                            </li> -->
                        </ul>
                    </div>
                </div>

            <!-- </div> -->
            <div class="c"></div>
            <ul class="ul-case">
                <li>
                    <router-link to="khal_detail">
                        <div class="block">
                            <div class="pic">
                                <img src="../assets/Images/news.jpg">
                                <div class="pic-warp">
                                    <div class="title">盘锦市住房公积金管理中心<br><p style="width:100%;font-size:12px;line-height:18px;margin-top:5px;">简化优化办事流程，实现多项业务办理“最多跑一次”</p></div>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </li>
                <li>
                    <router-link to="">
                        <div class="block">
                            <div class="pic">
                                <img src="../assets/Images/qidai.jpg">
                                <!-- <div class="pic-warp">
                                    <div class="title">锦州市住房中心</div>
                                </div> -->
                            </div>
                        </div>
                    </router-link>
                </li>
                <li>
                    <router-link to="">
                        <div class="block">
                            <div class="pic">
                                <img src="../assets/Images/qidai.jpg">
                                <!-- <div class="pic-warp">
                                    <div class="title">锦州市住房中心</div>
                                </div> -->
                            </div>
                        </div>
                    </router-link>
                </li>
                <li>
                    <router-link to="">
                        <div class="block">
                            <div class="pic">
                                <img src="../assets/Images/qidai.jpg">
                                <!-- <div class="pic-warp">
                                    <div class="title">锦州市住房中心</div>
                                </div> -->
                            </div>
                        </div>
                    </router-link>
                </li>
                <li>
                    <router-link to="">
                        <div class="block">
                            <div class="pic">
                                <img src="../assets/Images/qidai.jpg">
                                <!-- <div class="pic-warp">
                                    <div class="title">锦州市住房中心</div>
                                </div> -->
                            </div>
                        </div>
                    </router-link>
                </li>
                <li>
                    <router-link to="">
                        <div class="block">
                            <div class="pic">
                                <img src="../assets/Images/qidai.jpg">
                                <!-- <div class="pic-warp">
                                    <div class="title">锦州市住房中心</div>
                                </div> -->
                            </div>
                        </div>
                    </router-link>
                </li>
            </ul>
        </div>
            <div class="c h50"></div>
            <div class="c h50"></div>
            <div class="c h50"></div>
            <!-- <div class="pagess">
                <ul >
                    <li v-if='pageNum > 1'>首页</li>
                    <li v-if='pageNum > 1'>上一页</li>
                    <li v-for="(item,index) in pages" :class="{'thisclass':index==(pageNum-1)}">{{index+1}}</li>
                    <li v-if="pageNum < pages">下一页</li>
                    <li v-if="pageNum < pages">末页</li>
                </ul>
            </div> -->
        </div>
    </div>
    <!-- end #bd -->
</div>
</template>
<style>
.bannerImg{
    background-image: url(../assets/Images/casebanner.jpg)
}
</style>

<script>
import '../assets/Scripts/lib.js'
import '../assets/Scripts/flexslider.js'
import {flexslider} from '../assets/Scripts/banner.js'
import { getCustomerCaseList,getBanner } from '../assets/Scripts/fn.js' 
var self;
export default {
  data() {
    return {
        flag:1,
        caseType:[],
        caseList:[],
        pages:1,
        pageNum:1
    };
  },
  mounted() {
      flexslider()
    var isMobile;
    function mobileCheck() {
      isMobile = $("#m-hd").is(":visible");
    }

    $(window).resize(function(event) {
      mobileCheck();
      $(".ul-case li").removeClass("on");
      if (isMobile) {
        $(".ul-case").attr("id", "ul-mobile");
      } else {
        $(".ul-case").attr("id", "ul-pc");
      }
    });

    $("body").on("mouseenter mouseleave", "#ul-pc li", function() {
      $(this).toggleClass("on");
    });

    $("body").on("click", "#ul-mobile li", function() {
      $(this).toggleClass("on");
    });
  },
  methods:{
  }
};
</script>



// WEBPACK FOOTER //
// src/components/khal.vue